import { render, staticRenderFns } from "./leavetypecontent.vue?vue&type=template&id=04f81828"
import script from "./leavetypecontent.vue?vue&type=script&lang=js"
export * from "./leavetypecontent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports